<template>
  <div
    class="header-column"
    :style="`
      z-index: ${z_index};
      ${sticky_left?`left: ${sticky_left}`:''};`"
      >
    <slot/>
  </div>
</template>
<script>
export default {
  props: ['z_index', 'sticky_left'],
  data: () => ({
  }),
}
</script>
<style>
  .header-column{
    position: sticky;
    position: -webkit-sticky;
    display: flex;
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
    max-height: 75px;
    background-color: var(--v-color-4-base);
    padding: calc(5px * var(--taktplan_zoom));
    border-style: solid;
    border-color: var(--header_border_color);
    border-width: 1px 1px 1px 0px;
    justify-content: center;
    align-items: center;
    user-select: none;
    /* box-shadow: 1px 2px 0px 1px #000000; */
  }
</style>
